<template>
  <audio :key="audioSrc" class="audio-preview" controls v-if="audioSrc">
    <source :src="audioSrc" type="audio/mpeg" />
  </audio>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{ nodeSrc?: string | null; file?: File | null }>();

const audioSrc = computed(() => {
  if (props.file && typeof props.file !== "string") return URL.createObjectURL(props.file);
  else return props.nodeSrc;
});
</script>

<style scoped lang="sass">
.audio-preview
  width: 100%
  height: 32px
  margin-top: 10px
</style>
